import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import {
  LaneService, ReasonService, SpotService, ViolationService,
  ViewViolationService, ModalService, CategoryService, UserGroupService, AlertService, CsvDataServiceService,
  ViolationCsvService,
  StorageService,
  StorageKey,
  LotService,
  UserService,
  ContractService,
  RegulationService
} from 'src/app/core/services';
import moment from 'moment';
import {
  Lane, Reason, Regulation, Spot, Violation, ComponentModal,
  Category, User, AlertItem, AlertType, MessageModal,
  Lot,
  FileType,
  LotSteps,
  StatusLot,
} from 'src/app/core/models';
import { DetailsViolationComponent } from 'src/app/modals/details-violation/details.component';
import { LoteInfoComponent } from 'src/app/modals/lote-info/lote-info.component';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { QuarantineStatus } from 'src/app/core/models/Quarantine';
import { ViewFileModalComponent } from 'src/app/shared/view-file-modal/view-file-modal.component';
import { getLotDescription } from 'src/app/core/utils/lotHistoryDescription';

@Component({
  selector: 'app-violations-view-contract',
  templateUrl: './contract.component.html',
  styleUrls: ['./contract.component.sass']
})
export class ViolationsViewContractComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('container', { static: true, read: ElementRef }) container: ElementRef;
  public fileTypes = Object.values(FileType);
  public fileTypesI18n = [];
  public get fileType() {
    return this._fileTipe;
  }
  public set fileType(value) {
    this._fileTipe = value;
    this.setMatrix();
  }

  public contractId: string;
  public contractName: string;
  public loading = false;
  public loadingMosaic = false;
  public contractViewViolationsSub: Subscription;
  public filterViewViolationsSub: Subscription;
  public periodViewViolationsSub: Subscription;
  public users: any[] = [];
  public filter: any = {};
  public startDate;
  public endDate;
  public contract: any = {};
  public timezone: string;
  public categories: Category[] = [];
  public violations: Violation[] = [];
  public lanes: Lane[] = [];
  public spots: Spot[] = [];
  public regulations: Regulation[] = [];
  public reasons: Reason[] = [];
  public situations: any[] = [];
  public params: any = {};
  public deleteEvent: EventEmitter<any> = new EventEmitter();
  public violationsStepsResource: any[] = [];
  public violationsSteps: any[] = [
    'validateLane',
    'validateCalibration',
    'validateSpeed',
    'validateFiles',
    'validateExemptPeriod',
    'validateViolationLimit',
    'verifyValid',
    'verifyInvalid',
    'triage',
    'typing',
    'verify',
    'validate',
    'lotAttribution',
    'internalAudit',
    'revision',
    'filter',
    'done',
    'quarantine',
    'verifyCFTV',
    'validateCFTV',
    'monitoringCFTV',
    'serialNumberGeneration'
  ];
  public quarantineStatusI18n = [];
  public quarantineStatus = Object.values(QuarantineStatus);
  public lots = [];
  public lotsByViolation = {};
  public typeViewViolation = 'violationReport';
  public violationMatrix: Array<Array<{
    item: Violation;
  }>> = [];
  public isLoading = false;
  public counter = 0;
  public retPageSize = null;
  public viewViolationChecked = true;
  public historiesByStep: any = {};
  public lotSteps = Object.values(LotSteps);
  public lotStepsI18n = [];
  public statusLot = Object.keys(StatusLot);
  public statusLotI18n = [];
  private x = 0;
  private y = 0;
  private _fileTipe = 'zoom';

  constructor(
    private activatedRoute: ActivatedRoute,
    private categoryService: CategoryService,
    private laneService: LaneService,
    private modalService: ModalService,
    private reasonsService: ReasonService,
    private spotService: SpotService,
    private viewViolationService: ViewViolationService,
    public violationService: ViolationService,
    private alertService: AlertService,
    private violationCSVService: ViolationCsvService,
    public storageService: StorageService,
    private lotService: LotService,
    private userService: UserService,
    private userGroupService: UserGroupService,
    private contractService: ContractService,
    private regulationService: RegulationService,
  ) { }

  async ngOnInit() {
    const user = this.storageService.get(StorageKey.currentUser);
    this.contractId = this.activatedRoute.snapshot.params.contractId;
    this.filter = {
      contractId: this.contractId, spotsIds: '', laneIds: '',
      regulationsIds: '', situationsIds: '', reasonsIds: '',
      numberSerie: '', numberPlate: '', numberId: ''
    };

    this.contractViewViolationsSub = this.viewViolationService.getDataViewViolation()
      .pipe(filter(result => Object.keys(result).length > 0))
      .subscribe(async (data: any) => {
        this.contract = data.contracts.filter(item => item.id === Number(this.contractId)).shift();
        this.contractName = this.contract.name;
        this.regulations = data.regulations;
        this.situations = data.situations;
        this.spots = await this.spotService.getAll({ contractId: this.contractId });
        this.lanes = await this.laneService.getAll({ contractId: this.contractId });
        this.reasons = await this.reasonsService.getAll({ contractId: this.contractId });
        this.reasons = this.reasons.sort((a, b): any => Number(a.code) - Number(b.code));
        this.categories = await this.categoryService.getAll({ regionId: this.contract.regionId });
        this.users = (await this.userService.getAll({ order: 'name' })).filter(u => u.name && u.name !== '');
        const params = {
          regionId: this.contract.regionId
        };
        if (this.contract.regulationIds) {
          params['id[in]'] = `[${this.contract.regulationIds}]`;
        }
        this.regulationService.getAll(params).then(regulations => {
          this.viewViolationService.emitDataViewContractViolation({
            regulations,
            situations: this.situations,
            spots: this.spots,
            lanes: this.lanes,
            lots: this.lots,
            reasons: this.reasons,
            categories: this.categories,
            users: this.users
          });

          this.filterViewViolationsSub = this.viewViolationService.getFilterViewViolation()
            .pipe()
            .subscribe(async (result: any) => {
              this.violations = [];
              const keys = Object.keys(result);
              for (const key of keys) {
                if (result[key] && result[key].length > 0) {
                  this.filter[key] = result[key];
                } else {
                  this.filter[key] = '';
                }
              }
              this.periodViewViolationsSub = this.viewViolationService.getPeriodViewViolation()
                .pipe()
                .subscribe(async (resultPeriod: any) => {
                  this.violationMatrix = [];
                  this.violations = [];
                  this.startDate = resultPeriod.startDate;
                  this.endDate = resultPeriod.endDate;
                  if (this.typeViewViolation === 'mosaic') {
                    this.setParamsMosaic();
                  } else {
                    this.setParams();
                  }
                });
            });
        });
      });
  }


  // eslint-disable-next-line @typescript-eslint/member-ordering
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setContainerHeight();
  }


  ngAfterViewInit() {
    setTimeout(() => {
      this.setContainerHeight();
    }, 0);
  }

  keyEvent(event) {
    switch (event.key) {
      case 'a':
        event.preventDefault();
        break;
    }
  }

  setParams() {
    this.violations = [];
    this.params = {};
    this.params.contractId = this.contractId;

    this.params['date[between]'] = `[${moment(this.startDate).format()},${moment(this.endDate).format()}]`;
    if (this.filter?.numberId) {
      this.params.passId = this.filter.numberId;
    }

    if (this.filter?.lotName) {
      this.params.lotName = this.filter.lotName;
    }

    if (this.filter?.numberSerie) {
      this.params['equipment.serialNumber'] = this.filter.numberSerie;
    }

    if (this.filter?.numberPlate) {
      this.params['vehicle.plate'] = this.filter.numberPlate;
    }

    if (this.filter?.spotsIds?.length > 0 && this.filter?.spotsIds?.length < this.spots.length) {
      const spotsIds = this.filter.spotsIds.map(Number);
      const lanesWithSpot = this.lanes.filter(lane => spotsIds.includes(lane.spotId)).map(lane => lane.code);
      this.params['laneCode[in]'] = `[${lanesWithSpot.join()}]`;
    }

    if (this.filter?.laneIds?.length > 0 && this.filter?.laneIds?.length < this.lanes.length) {
      const laneIds = this.filter.laneIds.map(Number);
      const lanesCode = this.lanes.filter(lane => laneIds.includes(lane.id)).map(lane => lane.code);
      this.params['laneCode[in]'] = `[${lanesCode.join()}]`;
    }

    if (this.filter?.regulationsIds?.length > 0 && this.filter?.regulationsIds?.length < this.regulations.length) {
      this.params['regulationId[in]'] = `[${this.filter.regulationsIds.join()}]`;
    }
    if (this.filter?.situationsIds && this.filter?.situationsIds?.length > 0) {

      if (this.filter?.situationsIds.length === 1 && this.filter?.situationsIds.includes('inProcess')) {
        this.params['step[notIn]'] = '[done,lotAttribution]';
      }

      if (this.filter?.situationsIds.length === 1 && this.filter?.situationsIds.includes('inProcess')) {
        this.params['status[in]'] = `[invalid,valid]`;
      }
      if (this.filter?.situationsIds.includes('valid')) {
        this.params['status[in]'] = `[valid]`;
      }
      if (this.filter?.situationsIds.includes('invalid')) {
        this.params['status[in]'] = `[invalid]`;
      }
      if (this.filter?.situationsIds.includes('invalid') && this.filter?.situationsIds.includes('valid')) {
        this.params['status[in]'] = `[vaid,invalid]`;
      }

      if (this.filter?.situationsIds.includes('valid')) {
        this.params['status[in]'] = `[valid]`;
      }
      if (this.filter?.situationsIds.includes('invalid')) {
        this.params['status[in]'] = `[invalid]`;
      }
      if (this.filter?.situationsIds.includes('invalid') && this.filter?.situationsIds.includes('valid')) {
        this.params['status[in]'] = `[vaid,invalid]`;
      }
      if (!this.filter.situationsIds.includes('inProcess')) {
        this.params['status[in]'] = `[${this.filter.situationsIds.join()}]`;
        this.params['step[in]'] = `[lotAttribution,done]`;
        this.filter.steps = ['lotAttribution', 'done'];
      }
    }
    const userIds = this.filter?.userIds || [];
    if (userIds.length > 0) {
      this.params.authorGroup = `[${userIds.join()}]`;
    }

    this.filter.reasonsIds = (this.filter.reasonsIds && this.filter?.reasonsIds.map(Number)) || [];
    if (this.filter?.reasonsIds.length > 0 && this.filter?.situationsIds.includes('invalid')
      && this.filter?.reasonsIds.length < this.reasons.length) {
      const reasonsCode = this.reasons.filter(reason => this.filter.reasonsIds.includes(reason.id)).map(reason => reason.code);
      this.params['reason.code[in]'] = `[${reasonsCode.join()}]`;
    }
    if (this.filter?.lotIds?.length > 0) {
      this.params.lotGroup = `[${this.filter.lotIds[0]}]`;
    }
    this.params.order = 'date';
    this.params.pageSize = 10;
    this.loading = true;
  }

  setParamsMosaic() {
    this.params = {};
    this.params.contractId = this.contractId;
    this.params['date[between]'] = `[${moment(this.startDate).format()},${moment(this.endDate).format()}]`;

    if (this.filter?.numberId) {
      this.params.passId = this.filter.numberId;
    }

    if (this.filter?.lotName) {
      this.params.lotName = this.filter.lotName;
    }

    if (this.filter?.numberSerie) {
      this.params.serialNumber = this.filter.numberSerie;
    }

    if (this.filter?.numberPlate) {
      this.params.plate = this.filter.numberPlate;
    }

    if (this.filter?.spotsIds.length > 0 && this.filter?.spotsIds.length < this.spots.length) {
      const spotsIds = this.filter.spotsIds.map(Number);
      const lanesWithSpot = this.lanes.filter(lane => spotsIds.includes(lane.spotId)).map(lane => lane.code);
      this.params.laneCode = lanesWithSpot.join();
    }

    if (this.filter?.laneIds.length > 0 && this.filter?.laneIds.length < this.lanes.length) {
      const laneIds = this.filter.laneIds.map(Number);
      const lanesCode = this.lanes.filter(lane => laneIds.includes(lane.id)).map(lane => lane.code);
      this.params.laneCode = lanesCode.join();
    }

    if (this.filter?.regulationsIds.length > 0 && this.filter?.regulationsIds.length < this.regulations.length) {
      this.params.regulationId = this.filter.regulationsIds.join();
    }

    if (this.filter?.situationsIds && this.filter?.situationsIds.length > 0) {
      this.params.status = this.filter.situationsIds.join();
    }
    if (this.filter?.userIds?.length > 0) {
      this.params.authorId = `${this.filter.userIds.join()}`;
    }

    this.filter.reasonsIds = (this.filter.reasonsIds && this.filter?.reasonsIds.map(Number)) || [];
    if (this.filter?.reasonsIds.length > 0 && this.filter?.situationsIds.includes('invalid')
      && this.filter?.reasonsIds.length < this.reasons.length) {
      const reasonsCode = this.reasons.filter(reason => this.filter.reasonsIds.includes(reason.id)).map(reason => reason.code);
      this.params.reasonCode = `${reasonsCode.join()}`;
    }
    if (this.filter?.lotIds?.length > 0) {
      this.params.lotId = this.filter.lotIds.join();
      this.params.lotIdAudit = this.filter.lotIdAudit.join();
    }
    this.params.order = 'date';
    this.params.page = 1;
    this.params.pageSize = 10;
    this.params.order = 'id';
  }

  onLoadingChange(value: boolean) {
    this.loadingMosaic = value;
  }

  async setViolations(list: any = []) {
    if (list.length === 0) {
      return;
    }
    this.lots = [];
    this.violations = [];
    list.map(violation => {
      violation = this.addHistory(violation);
      this.violations.push(violation);
    });

    const lotIds = [...new Set(this.violations.map(e => e.lotId).filter(e => e))];
    if (lotIds.length > 0) {
      const res = await this.lotService.list({ contractId: this.contractId, 'id[in]': `[${lotIds.join(',')}]` });
      this.lots = res.result;
    }

    for (const lot of this.lots) {
      if (this.lotsByViolation['lot' + lot.id] == null) {
        this.lotsByViolation['lot' + lot.id] = lot;
      }
      this.setLotHistory(lot.id);
    }
    if (this.typeViewViolation === 'mosaic') {
      this.setMatrix();
    }
  }

  setMatrix() {
    this.counter = 0;
    const size = [5, this.retPageSize / 5];
    this.x = size[0];
    this.y = size[1];
    const n = this.x * this.y;
    const violations = this.violations.slice(0, n);
    this.violationMatrix = [];
    let row = [];
    for (const violation of violations) {
      violation.date = new Date(moment(violation.date).add(3, 'hours').utcOffset('-0300').format());
      row.push({
        item: violation,
        file: (violation.files.find(f => f.type === this.fileType) || { urlCurrent: undefined }).urlCurrent
      });
      if (row.length === this.x) {
        this.violationMatrix.push(row);
        row = [];
      }
    }
    if (row.length > 0) {
      this.violationMatrix.push(row);
    }
  }

  setContainerHeight() {
    const div = this.container.nativeElement as HTMLDivElement;
    const height = window.innerHeight - div.offsetTop - 71;
    div.style.height = height + 'px';
    this.setMatrix();
  }

  getLotInfo(id) {
    const lot = this.lots.find(l => l.id === id);
    return lot && lot.name;
  }

  getSpot(lane) {
    const laneInfo = this.lanes.filter(item => item.code === lane).shift();
    if (laneInfo) {
      const spotInfo = this.spots.filter(item => item.id === laneInfo.spotId).shift();
      return (spotInfo && spotInfo.code) || '-';
    }
  }

  getRegulationCode(regulation) {
    return this.regulations.filter(item => item.id === regulation).map(item => item.code).shift();
  }

  getRegulationInfo(regulation) {
    const regulationInfo = this.regulations.filter(item => item.id === regulation).shift();
    return (regulationInfo && regulationInfo?.description) || '';
  }

  getSpotInfo(lane) {
    const laneInfo = this.lanes.filter(item => item.code === lane).shift();
    if (laneInfo) {
      const spotInfo = this.spots.filter(item => item.id === laneInfo.spotId).shift();
      return (spotInfo && spotInfo.prettyName) || '-';
    }
  }
  changeColor(value) {
    this.typeViewViolation = value ? 'violationReport' : 'mosaic';
    this.viewViolationChecked = value;
    this.violations = [];
    this.violationMatrix = [];
    if (this.typeViewViolation === 'mosaic') {
      this.setParamsMosaic();
    } else {
      this.setParams();
    }
  }
  async showDetails(violation) {
    await this.modalService.show(new ComponentModal(DetailsViolationComponent, { violation }))
      .catch((error) => console.log(error));
  }

  public downloadAsPDF(violation) {
    this.violationService.ait(violation.id).then(ait => {
      const fileTemplate = ait;
      const bodyTemplate = fileTemplate.body;
      const iframe = document.createElement('iframe');
      document.body.appendChild(iframe);
      iframe.contentWindow.document.open();
      iframe.contentWindow.document.write(bodyTemplate);
      iframe.contentWindow.document.close();
      let bodyAit: HTMLElement = iframe.contentWindow.document.querySelector('.align-table');
      if (bodyAit == null) {
        bodyAit = iframe.contentWindow.document.querySelector('body');
      }
      html2canvas(bodyAit,
        {
          allowTaint: false,
          useCORS: true,
          logging: true
        }
      ).then(canvas => {
        const contentDataURL = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4'); // A4 size page of PDF
        const width = pdf.internal.pageSize.getWidth();
        const height = canvas.height * width / canvas.width;
        pdf.addImage(contentDataURL, 'PNG', 0, 0, width, height);
        pdf.save(`${violation.passId}.pdf`); // Generated PDF
        document.body.removeChild(iframe);
      });
    }).catch(error => {
      this.alertService.show(new AlertItem('AitError', AlertType.danger));
    });
    ;
  }

  async showHistory(lotId) {
    await this.modalService.show(new ComponentModal(LoteInfoComponent, { lotId, contractId: this.contractId }))
      .catch((error) => console.log(error));
  }

  getHistories(history) {
    return this.getNormalizedHistory(history);
  }

  getLaneInfo(lane) {
    return this.lanes.filter(item => item.code === lane).map(item => item.prettyNames && item.prettyNames[0]).shift();
  }

  getAuthorInfo(history) {
    let item;
    let itemHistory;

    const lastStep = Object.keys(history) || [];
    if (lastStep.length > 0) {
      itemHistory = history[lastStep[lastStep.length - 1]];
    }

    if (Array.isArray(itemHistory)) {
      item = itemHistory[itemHistory.length - 1];
    } else {
      item = itemHistory;
    }
    return item?.authorName || null;
  }
  getNormalizedHistory(violationsHistory = []) {
    const resultNormalized = [];
    Object.entries(violationsHistory).map(item => {
      const id: string = item[0];
      const data: any = item[1];

      if (Array.isArray(data)) {
        data.map(itemInside => {
          const itemObj: any = {};
          const stepName = this.violationsStepsResource.filter(step => step.id === id).shift();
          itemObj.id = id;
          itemObj.title = stepName ? stepName.value : null;
          itemObj.date = itemInside.date;
          if (itemInside.authorName) {
            itemObj.authorName = itemInside.authorName;
          }
          resultNormalized.push(itemObj);
        });
      } else if (id === 'CFTV') {
        Object.entries(data || []).map(itemCFTV => {
          const dataCFTV: any = itemCFTV[1];
          dataCFTV.map(itemInside => {
            const idCFTV: string = itemCFTV[0];
            const itemObj: any = {};
            const stepName = this.violationsStepsResource.filter(step => step.id === idCFTV).shift();
            itemObj.id = idCFTV;
            itemObj.title = stepName ? stepName.value : null;
            itemObj.date = itemInside.date;
            if (itemInside.authorName) {
              itemObj.authorName = itemInside.authorName;
            }
            resultNormalized.push(itemObj);
          });
        });
      } else {
        const itemObj: any = {};
        itemObj.id = id;
        itemObj.title = this.violationsStepsResource?.filter(step => step.id === id).shift()?.value || null;
        itemObj.date = data.date;
        if (data.authorName) {
          itemObj.authorName = data.authorName;
        }
        resultNormalized.push(itemObj);
      }
    });
    resultNormalized.sort((a, b) => +new Date(a.date) - +new Date(b.date));
    return resultNormalized;
  }

  setResources(value) {
    this.violationsStepsResource = value;
  }

  exportCsv() {
    const params: any = {
      startDate: this.params['date[gte]'],
      endDate: this.params['date[lte]'],
      contractId: this.contractId
    };
    if (this.filter?.spotsIds?.length > 0) {
      params.spotsIds = this.filter.spotsIds;
    }
    if (this.filter?.laneIds?.length > 0) {
      params.laneIds = this.filter.laneIds;
    }
    if (this.filter?.situationsIds?.length > 0) {
      params.situationsIds = this.filter.situationsIds;
    }
    if (this.filter?.reasonsIds?.length > 0) {
      params.reasonsIds = this.filter.reasonsIds;
    }
    if (this.filter?.numberId) {
      params.numberId = this.filter.numberId;
    }
    if (this.filter?.numberPlate) {
      params.numberPlate = this.filter.numberPlate;
    }
    if (this.filter?.numberSerie) {
      params.numberSerie = this.filter.numberSerie;
    }
    if (this.filter?.regulationsIds?.length > 0) {
      params.regulationIds = this.filter.regulationsIds.map(Number);
    }
    if (this.filter?.steps?.length > 0) {
      params.steps = this.filter.steps;
    }
    const currentUser = this.storageService.get(StorageKey.currentUser);
    this.violationCSVService.violationViewCSV(params).then(async () => {
      await this.modalService.show(new MessageModal('Relatório CSV - Consulta de Infração',
        `Será enviado um email para ${currentUser.email} quando finalizar
      a geração do arquivo CSV. Favor aguarde`, false));
    }).catch(() => {
      this.alertService.show(new AlertItem('ReportCSV', AlertType.danger));
    });
  }
  getViolationStep(step) {
    const steps = {
      validateLane: 'Validar faixa',
      validateCalibration: 'Validar aferição',
      validateSpeed: 'Validar velocidade',
      validateFiles: 'Validar arquivo',
      validateExemptPeriod: 'Período isento',
      validateVehicleWhiteList: 'Veículo Isento',
      validateViolationLimit: 'Limite de infrações',
      verifyValid: 'Verificação de válidas',
      verifyInvalid: 'Verificação de inválidas',
      validateEquipment: 'Equipamento inválido',
      triage: 'Triagem',
      typing: 'Digitação',
      verify: 'Verifiação',
      validate: 'Validação',
      lotAttribution: 'Atribuição de lote',
      internalAudit: 'Auditoria interna',
      revision: 'Revisão',
      filter: 'Filtro',
      verifyCFTV: 'Verificacao CFTV',
      validateCFTV: 'Validacao CFTV',
      monitoringCFTV: 'Monitoramento CFTV',
      done: 'Concluído'
    };
    return steps[step];
  }
  getViolationSituation(status) {
    if (status !== 'valid' && status !== 'invalid') {
      return 'Em processamento';
    }
    if (status === 'valid') {
      return 'Válida';
    }
    if (status === 'invalid') {
      return 'Inválida';
    }
  }
  getStatusQuarantine(quarantineReason = null) {
    if (this.quarantineStatusI18n.length === 0 || quarantineReason == null) {
      return;
    }
    return this.quarantineStatusI18n.find(q => q.id === quarantineReason).value;
  }
  ngOnDestroy(): void {
    window.removeEventListener('keydown', event => this.keyEvent(event));
  }

  openImgModal(violationItem, event = null) {
    if (event != null) {
      event.stopPropagation();
    }
    this.modalService.show(new ComponentModal(ViewFileModalComponent,
      { files: violationItem.item.files.map(f => f.urlCurrent), shownFile: violationItem.file })).catch(() => { });
  }
  setLotHistory(id = null) {
    if (id == null) {
      return;
    }
    const lot = this.lotsByViolation['lot' + id];
    if (this.historiesByStep[lot.id] == null) {
      this.historiesByStep[lot.id] = null;
      if (lot?.HistoryLots?.length > 0) {
        const historiesByStep = lot.HistoryLots.reduce((acc, item) => {
          if (!acc[item.step]) {
            acc[item.step] = [];
          }
          acc[item.step].push(item);
          return acc;
        }, {});
        const allHistories = [];
        const stepKeys = Object.keys(historiesByStep);
        for (const step of stepKeys) {
          for (const history of historiesByStep[step]) {
            allHistories.push(history);
          }
        }
        if (allHistories.length > 0) {
          this.historiesByStep[lot.id] = allHistories.sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
        }
      }
    }
  }
  setLotStepsI18n(lotSteps) {
    this.lotStepsI18n = lotSteps;
  }

  convertLotDescription(description: string) {
    return getLotDescription(description);
  }

  getStepLot(step) {
    if (this.lotStepsI18n.length === 0) {
      return;
    }
    return this.lotStepsI18n.find(s => s.id === step)?.value || '-';
  }
  getStatusLot(statusLot) {
    const status = this.statusLotI18n.find(s => s.id === statusLot);
    return (status && status.value) || '';
  }

  addHistory(violation = null) {
    const histories: any = violation?.Histories || [];
    const history = {};
    // eslint-disable-next-line guard-for-in
    for (const i in histories) {
      const historyByStep = histories[i];
      const step = historyByStep.step || null;
      if (step && step !== 'stand-by') {
        const data = {
          step,
          date: historyByStep.date,
          authorId: historyByStep.authorId,
          authorName: historyByStep.authorName,
          registryNumber: historyByStep.registryNumber
        };
        if (!history[step]) {
          if (['lotAttribution', 'quarantine', 'serialNumberGeneration', 'CFTV'].includes(step)) {
            history[step] = {};
          } else {
            history[step] = [];
          }
        }
        if (['lotAttribution', 'quarantine', 'serialNumberGeneration', 'CFTV'].includes(step)) {
          history[step] = data;
        } else {
          history[step].push(data);
        }
      }
    }
    if (Object.keys(history).length > 0) {
      violation.history = history;
    }
    return violation;
  }
}
